/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Transition_Redaction_LabelInputs */

const bn_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিডাকশন`)
};

const de_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REDAKTION`)
};

const el_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΣΥΝΤΑΞΗ`)
};

const en_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REDACTION`)
};

const es_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REDACCIÓN`)
};

const fr_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MASQUAGE`)
};

const hi_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपादकीय विभाग`)
};

const hu_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SZERKESZTÉS`)
};

const id_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REDAKSI`)
};

const it_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REDAZIONE`)
};

const ja_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集`)
};

const ko_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`편집`)
};

const nl_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REDACTIE`)
};

const pl_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRZERÓBKA`)
};

const pt_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REDAÇÃO`)
};

const ru_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`РЕДАКТИРОВАНИЕ`)
};

const sv_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REDAKTION`)
};

const tr_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REDAKSİYON`)
};

const uk_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`РЕДАКЦІЯ`)
};

const vi_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GIẢM GIÁ`)
};

const zh_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑`)
};

const zh_hant_cipher_transition_redaction_label = /** @type {(inputs: Cipher_Transition_Redaction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編輯`)
};

/**
* | output |
* | --- |
* | "REDACTION" |
*
* @param {Cipher_Transition_Redaction_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_transition_redaction_label = /** @type {((inputs?: Cipher_Transition_Redaction_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Transition_Redaction_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_transition_redaction_label(inputs)
	if (locale === "de") return de_cipher_transition_redaction_label(inputs)
	if (locale === "el") return el_cipher_transition_redaction_label(inputs)
	if (locale === "en") return en_cipher_transition_redaction_label(inputs)
	if (locale === "es") return es_cipher_transition_redaction_label(inputs)
	if (locale === "fr") return fr_cipher_transition_redaction_label(inputs)
	if (locale === "hi") return hi_cipher_transition_redaction_label(inputs)
	if (locale === "hu") return hu_cipher_transition_redaction_label(inputs)
	if (locale === "id") return id_cipher_transition_redaction_label(inputs)
	if (locale === "it") return it_cipher_transition_redaction_label(inputs)
	if (locale === "ja") return ja_cipher_transition_redaction_label(inputs)
	if (locale === "ko") return ko_cipher_transition_redaction_label(inputs)
	if (locale === "nl") return nl_cipher_transition_redaction_label(inputs)
	if (locale === "pl") return pl_cipher_transition_redaction_label(inputs)
	if (locale === "pt") return pt_cipher_transition_redaction_label(inputs)
	if (locale === "ru") return ru_cipher_transition_redaction_label(inputs)
	if (locale === "sv") return sv_cipher_transition_redaction_label(inputs)
	if (locale === "tr") return tr_cipher_transition_redaction_label(inputs)
	if (locale === "uk") return uk_cipher_transition_redaction_label(inputs)
	if (locale === "vi") return vi_cipher_transition_redaction_label(inputs)
	if (locale === "zh") return zh_cipher_transition_redaction_label(inputs)
	return zh_hant_cipher_transition_redaction_label(inputs)
});